import { actions } from '.';

export function getIssueTypesSucceed(issueTypes = []) {
  return {
    type: actions.GET_ISSUE_TYPES_SUCCEED,
    payload: issueTypes
  };
}
